module.exports = __webpack_public_path__ + "static/media/homeGraphic.92b129f4.png";